export enum WebhooksSearchTabType {
    Webhooks = 'webhooks',
    FailedWebhooks = 'failedWebhooks',
}
